import React from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Courses from './components/courses/Courses'
import Experience from './components/experience/Experience'
import Services from './components/services/Services'
import Portfolio from './components/portfolio/Portfolio'
import Hackathons from './components/hackthons/Hackathons'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

const App = () => {
  return (
    <>
      <div>
        <Header />
        <Nav />
        <About />
        <Courses />
        <Experience />
        <Services />
        <Portfolio />
        <Hackathons />
        <Contact />
        <Footer />
      </div>
    </>
  )
}

export default App